import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
}

const TGBCommonId = ({ helper, ...rest }: Props) => {
  const name = 'agent'
  const label = 'TGB Common ID'

  return <TextInput name={name} label={label} helper={helper} {...rest} />
}

export default TGBCommonId
